"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.dm.communicationType.wa': 'WA',
    'whatsapp.dm.communicationType.tele': 'TELE',
    'whatsapp.dm.loading': 'Ładowanie...',
    'whatsapp.dm.back': 'Wróć',
    'whatsapp.dm.contactInfo': 'Informacje o kontakcie',
    'whatsapp.dm.contactName': 'Nazwa',
    'whatsapp.dm.contactId': 'ID kontaktu',
    'whatsapp.dm.messages': 'Wiadomości',
    'whatsapp.dm.noMessages': 'Brak wiadomości dla wybranego zakresu dat.',
    'whatsapp.dm.dateFrom': 'Od',
    'whatsapp.dm.dateTo': 'Do',
    'whatsapp.dm.summarize': 'Podsumuj',
    'whatsapp.dm.summarizeDone': 'Podsumowanie DM wygenerowane pomyślnie.',
    'whatsapp.dm.summarizeFailed': 'Nie udało się wygenerować podsumowania DM.',
    'whatsapp.dm.botSender': 'Bot',
    'whatsapp.dm.media.attachment': 'Załącznik',
    'whatsapp.dm.summaries.title': 'Podsumowania',
    'whatsapp.dm.summaries.empty': 'Brak podsumowań.',
    'whatsapp.dm.summaries.date': 'Data',
    'whatsapp.dm.summaries.excerpt': 'Fragment',
    'whatsapp.dm.summaries.modalTitle': 'Podsumowanie DM',
    'whatsapp.dm.stats.contacts': 'Kontakty',
    'whatsapp.dm.syncMessages.button': 'Synchronizuj wiadomości',
    'whatsapp.dm.syncMessages.failed': 'Nie udało się zsynchronizować wiadomości',
    'whatsapp.dm.sendMessage.title': 'Wyślij wiadomość',
    'whatsapp.dm.sendMessage.placeholder': 'Wpisz wiadomość...',
    'whatsapp.dm.sendMessage.send': 'Wyślij',
    'whatsapp.dm.sendMessage.success': 'Wiadomość wysłana pomyślnie',
    'whatsapp.dm.sendMessage.failed': 'Nie udało się wysłać wiadomości',
    'whatsapp.dm.media.download': 'Pobierz',
    'whatsapp.dm.media.downloading': 'Pobieranie...',
    'whatsapp.dm.media.downloadFailed': 'Nie udało się pobrać multimediów',
    'whatsapp.dm.stats.total': 'Łącznie',
};
